export default function isString(s) {
  return typeof s === 'string'
}